import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const FAQ = [
  {
    q: "Candidatar-me custa alguma coisa?",
    a: "Não. Criar conta, procurar vagas, candidatar-se, guardar favoritos, criar alertas e usar a análise de CV por IA é gratuito para candidatos. Não pedimos cartão de crédito.",
  },
  {
    q: "Quem consegue ver o meu CV?",
    a: "O teu PDF fica em armazenamento privado. Só tu, o administrador da plataforma e as empresas às quais te candidataste conseguem abri-lo. Podes substituir ou apagar o CV a qualquer momento, e também apagar a conta (RGPD).",
  },
  {
    q: "Quanto custa publicar uma vaga?",
    a: "Publicar é gratuito e a vaga fica ativa 30 dias. Se quiseres mais visibilidade tens 3 tiers avulsos: EXPRESS 15€ (5 dias, urgência), SILVER 45€ (10 dias, equilíbrio) e PREMIUM GOLD 99€ (30 dias, prestígio máximo). Também há packs de créditos com desconto: PACK START 99€ (3× SILVER), PACK BUSINESS 299€ (5× SILVER + 2× GOLD) e PACK CORPORATE 599€ (10× SILVER + 5× GOLD). Para volume alto de recrutamento temos ainda os packs AI Triagem: 90€ (50 análises) e 150€ (100 análises).",
  },
  {
    q: "Como funciona a inteligência artificial?",
    a: "São três funções: geração de anúncios a partir de palavras-chave (empresas), análise do CV com sugestões de melhoria (candidatos) e um match score de 0 a 100 entre candidato e vaga com resumo automático. Existe um limite de utilizações por hora para evitar abusos — quem tem premium via convites não tem limite. As empresas podem ainda fazer triagem em massa até 5 candidaturas por chamada.",
  },
  {
    q: "Como uso o filtro por distância em km?",
    a: "No formulário de pesquisa avançada escolhes um concelho de referência (o teu perfil pré-preenche se estiver definido) e um raio: 10, 25, 50, 100 ou 200 km. A lista mostra só vagas dentro do raio ordenadas por distância, e cada cartão indica \"a X km\" do teu ponto de partida. Cobre os 308 concelhos de Portugal continental, Açores e Madeira.",
  },
  {
    q: "O que são os alertas de emprego?",
    a: "Guardas uma pesquisa (por exemplo, \"Restauração + Lisboa\") e sempre que aparecer uma vaga que corresponda recebes a notificação. Podes ter vários alertas em simultâneo e apagá-los a qualquer momento no teu painel.",
  },
  {
    q: "Em que zonas do país têm vagas?",
    a: "Todo o país: os 18 distritos do continente mais os Açores e a Madeira, com os 308 concelhos disponíveis nos filtros. Podes ainda pesquisar por distância — só vagas até 10, 25, 50, 100 ou 200 km do teu concelho, com a distância indicada em cada vaga.",
  },
  {
    q: "Vi vagas com a marca IEFP. O que são?",
    a: "Importamos automaticamente ofertas públicas do portal IEFP para aumentar a oferta disponível. Essas vagas têm a etiqueta \u201cFonte: IEFP\u201d e a candidatura é feita no portal do IEFP, com o botão que te levamos diretamente lá.",
  },
  {
    q: "O que é o programa de convites?",
    a: "Cada conta tem um código de convite único. Um candidato que traga 3 amigos registados ganha 30 dias de premium (IA sem limites e badge no perfil). Uma empresa que convide outra empresa recebe um crédito de DESTAQUE quando essa empresa fizer a primeira compra. Vês o teu código e recompensas no painel.",
  },
  {
    q: "As vagas são verificadas?",
    a: "Sim. Todas as vagas publicadas por empresas passam por moderação antes de ficarem visíveis, e as contas de empresa são aprovadas manualmente. As vagas importadas do IEFP são oficiais. Se encontrares algo suspeito, avisa-nos.",
  },
  {
    q: "As empresas podem anunciar-se com banners?",
    a: "Sim. A administração pode publicar banners publicitários em cinco posições: hero da homepage, topo da lista de vagas, entre resultados, barra lateral e página da vaga. Cada banner pode ser segmentado por distrito e categoria e traz métricas de impressões, cliques e CTR.",
  },
  {
    q: "Que passos seguem depois de me candidatar?",
    a: "1) Recebemos a candidatura e ficas em \u201cSubmetida\u201d. 2) A empresa vê o teu perfil, CV e match score e passa a candidatura para \u201cEm análise\u201d. 3) Se houver interesse, avança para \u201cEntrevista\u201d. 4) Depois recebes o desfecho: \u201cAceite\u201d ou \u201cRejeitada\u201d. Todos os estados aparecem no teu painel em tempo real e a empresa pode adicionar-te uma nota ao mudar de estado.",
  },
];

export const Faq = () => (
  <section id="faq" className="bg-white border-t border-black/5 scroll-mt-20">
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-20">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-3">Perguntas frequentes</p>
      <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl text-slate-900">
        Tudo o que costumam perguntar
      </h2>
      <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
        {FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-black/5">
            <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-heading font-bold tracking-tight text-[15px] text-slate-900 hover:text-amber-600 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
